import { Outlet } from "react-router-dom";
import { useUserContext } from "../Contexts/userContext";
import { useGlobalError } from "../Contexts/GlobalErrorContext";
import { FullPageError } from "../Components/CustomUi/CustomAlert";
import { useCombinedLoadingContext } from "../Contexts/CombinedLoadingContext";

function ErrorRoute() {
  const { user } = useUserContext();
  const { error: globalError } = useGlobalError();
  const { combinedLoading } = useCombinedLoadingContext();

  if (globalError && user && !combinedLoading) {
    return <FullPageError {...globalError} />;
  }

  return <Outlet />;
}

export default ErrorRoute;
